import React from 'react'
import { IconButton, Tooltip, useMediaQuery, useTheme } from '@mui/material'
import { useEffect, useState } from 'react'
import NotificationsIcon from '@mui/icons-material/Notifications'
import AuthService from '../../service'

export default function AlertNotification() {
    const theme = useTheme()
    const profile = new AuthService().getProfile()
    const isTouchDevice = typeof window !== "undefined" && ("ontouchstart" in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0)
    const isMobile = useMediaQuery((theme) => theme.breakpoints.down("md"), { defaultMatches: true, })
    const shouldDisableWidget = isMobile || isTouchDevice
    const [loaded, setLoaded] = useState(false)

    useEffect(() => {
        if (window.sischefNotificationWidget || shouldDisableWidget) return

        const script = document.createElement("script")
        script.async = true
        script.type = "text/javascript"
        // script.src = "http://localhost:3100/libs/sischef-notification.js" // -- descomentar para rodar em dev
        script.src = "https://monitor-impressao.sischef.com/libs/sischef-notification.js"
        script.onload = () => setLoaded(true)

        document.body.appendChild(script)

        return () => {
            const sischefWidgetIframe = document.querySelector(".sischef-widget-iframe")

            if (sischefWidgetIframe) {
                sischefWidgetIframe.remove()
            }

            document.body.removeChild(script)
        }
    }, [shouldDisableWidget])

    useEffect(() => {
        if (!loaded || !window.sischefNotificationWidget || shouldDisableWidget) return

        window.sischefNotificationWidget.init({
            theme: theme.palette.mode,
            application: "SISCHEF_ANALYTICS",
            username: profile.username,
            format: 'notification'
        })

        return () => {
            if (window.sischefNotificationWidget) {
                window.sischefNotificationWidget.destroy()
            }
        }
    }, [loaded, profile.username, theme.palette.mode, shouldDisableWidget])

    if (shouldDisableWidget) {
        return null
    }

    return (
        <Tooltip disableInteractive title="Notificações">
            <IconButton id="sischef-widget-wrapper" size="large">
                <NotificationsIcon />
            </IconButton>
        </Tooltip>
    )
}